import React from "react";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-inner">
        <div className="badge">US Fans • Streaming Companion</div>
        <h1>Latest Sports Buzz & Where to Watch Big Fights Online</h1>
        <p>
          Follow US sports headlines from NFL, NBA & MLB while tracking live
          boxing, MMA and international soccer nights available via our
          streaming partners.
        </p>
        <a
          className="cta-primary"
          href="https://www.awin1.com/cread.php?awinmid=126253&awinaffid=2941253&ued=https%3A%2F%2Fwww.dazn.com%2Fen-US%2Fwelcome
 "
        >
          Go to Fight Streams
        </a>
        <div className="hero-note">
          Live & on-demand availability depends on your location. Always check
          final details on the provider page.
        </div>
      </div>
    </section>
  );
};

export default Hero;
